/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBezierCurve: {
  name: 'bezier-curve';
  data: string;
} = {
  name: 'bezier-curve',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 3a1 1 0 0 1-1.259.966l-2.3 2.301c.222.086.435.191.636.314C15.26 4.504 18.441 4 22 4a1 1 0 1 1 0 2c-3.213 0-5.876.433-8.506 2.05a4 4 0 0 1-5.443 5.443C6.433 16.125 6 18.788 6 22a1 1 0 1 1-2 0c0-3.559.504-6.741 2.58-9.923a3.988 3.988 0 0 1-.313-.637l-2.3 2.301A1.001 1.001 0 1 1 2 14a1 1 0 0 1 1.259-.966l2.75-2.751a4 4 0 0 1 4.273-4.273l2.752-2.751A1.001 1.001 0 1 1 15 3Zm-7 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" fill="currentColor"/></svg>`,
};
